<!--Back Button-->
<div class="container">
  <div class="d-none d-lg-block back-button-padding">
    <button class="back-btn border-0 d-flex align-items-center justify-content-center" [routerLink]="'/rewards/auctions'">
      <span class="material-icons text-white">arrow_back_ios_new</span>
    </button>
  </div>
</div>
<!-- Points Summary -->
<fgb-points-summary-bar [backButtonTitle]="'Auctions'"></fgb-points-summary-bar>

<!-- Auction Details -->
<fgbcl-auction-details [auctionId]="id"></fgbcl-auction-details>
